module.exports = __webpack_public_path__ + "img/4.66bd9674.png";